import {
  Component,
  Input,
  HostBinding,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';

export type ActionContentPosition = 'center' | 'end';

@Component({
  selector: 'td-wb-page-action-panel',
  template: '<ng-content />',
  styleUrls: ['page-action-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageActionPanelComponent {
  /* eslint-disable lines-between-class-members */
  @Input()
  set top(value: boolean) {
    this._top = value;
  }
  @HostBinding('class.td-wb-page-action-panel--top')
  get topPadding(): boolean {
    return this._top;
  }

  @Input()
  set bottom(value: boolean) {
    this._bottom = value;
  }
  @HostBinding('class.td-wb-page-action-panel--bottom')
  get bottomPadding(): boolean {
    return this._bottom;
  }
  @Input()
  set left(value: boolean) {
    this._left = value;
  }
  @HostBinding('class.td-wb-page-action-panel--left')
  get leftPadding(): boolean {
    return this._left;
  }

  @Input()
  set right(value: boolean) {
    this._right = value;
  }
  @HostBinding('class.td-wb-page-action-panel--right')
  get rightPadding(): boolean {
    return this._right;
  }

  @Input() position: ActionContentPosition;
  @HostBinding('class.td-wb-page-action-panel') pageActionPanel: boolean = true;
  @HostBinding('class.td-wb-page-action-panel--center')
  get isCenter(): boolean {
    return this.position === 'center';
  }
  @HostBinding('class.td-wb-page-action-panel--end')
  get isEnd(): boolean {
    return this.position === 'end';
  }
  /* eslint-enable lines-between-class-members */

  private _top: boolean = false;
  private _bottom: boolean = false;
  private _left: boolean = true;
  private _right: boolean = true;
}
